import { render, staticRenderFns } from "./MassAddPeople.vue?vue&type=template&id=2734c930&"
import script from "./MassAddPeople.vue?vue&type=script&lang=js&"
export * from "./MassAddPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports